var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',[_vm._v("Copyright  上海知身为信息网络科技有限公司  "),_c('a',{staticClass:"beian",attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"__blank"}},[_vm._v("沪ICP备2022013021号")])])])
}]

export { render, staticRenderFns }